import React, { useState } from "react";
import { auth } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const navigate = useNavigate();

  const handleSignup = async () => {
    if (!email || !password) {
      setMessage("⚠️ Please fill in both fields.");
      setMessageType("error");
      return;
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      setMessage("🎉 Signup successful! Redirecting...");
      setMessageType("success");

      setTimeout(() => {
        navigate("/dashboard");
      }, 1500);
    } catch (err) {
      setMessage(err.message);
      setMessageType("error");
    }
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Document Scanner Signup</h1>

        <div style={styles.formGroup}>
          <label style={styles.label}>Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            style={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button style={styles.button} onClick={handleSignup}>
          Signup
        </button>

        {message && (
          <div
            style={{
              ...styles.message,
              ...(messageType === "success" ? styles.success : styles.error),
            }}
          >
            {message}
          </div>
        )}

        <Link to="/" style={styles.link}>
          Already have an account? Login
        </Link>
      </div>
    </div>
  );
};

export default Signup;

const styles = {
  body: {
    background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "20px",
  },
  container: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    padding: "40px",
    borderRadius: "20px",
    width: "90%",
    maxWidth: "500px",
    boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)",
  },
  heading: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#FFD700",
    fontSize: "36px",
  },
  formGroup: {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "8px",
    fontWeight: "bold",
  },
  input: {
    padding: "12px",
    border: "none",
    borderRadius: "10px",
    fontSize: "16px",
    backgroundColor: "#ffffff",
    color: "#000000",
  },
  button: {
    backgroundColor: "#FFD700",
    color: "#000",
    fontWeight: "bold",
    padding: "15px",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    cursor: "pointer",
    width: "100%",
    marginTop: "20px",
    transition: "background-color 0.3s ease",
  },
  message: {
    textAlign: "center",
    marginTop: "20px",
    fontSize: "16px",
  },
  success: {
    color: "#00FF99",
  },
  error: {
    color: "#FF6666",
  },
  link: {
    color: "#FFD700",
    display: "block",
    textAlign: "center",
    marginTop: "15px",
    textDecoration: "none",
  },
};
